import { LEGALSTATUS_OTHER } from '@/types/constants/legalStatus'

export const ORIGIN_CREATE_USER = t => [
  { value: 'Réseaux sociaux', name: t('enum.howKnowPharmacistGroup.socialMedia') },
  { value: 'Presse', name: t('enum.howKnowPharmacistGroup.press') },
  { value: 'Salons', name: t('enum.howKnowPharmacistGroup.salons') },
  { value: 'Conférences / Événements', name: t('enum.howKnowPharmacistGroup.conferences') },
  { value: 'Annonces', name: t('enum.howKnowPharmacistGroup.announcements') },
  { value: 'Recherche', name: t('enum.howKnowPharmacistGroup.research') },
  { value: 'Insight News', name: t('enum.howKnowPharmacistGroup.insightNews') },
  { value: 'Bouche à oreille', name: t('enum.howKnowPharmacistGroup.podcast') },
]

export const PERSON_CIVILITY = t => [
  { value: 'Monsieur', name: t('enum.personCivility.mr') },
  { value: 'Madame', name: t('enum.personCivility.mrs') },
]

export const SPECIALISATION_STUDENT = {
  Officine: 'Officine',
  Industrie: 'Industrie',
  Internat: 'Internat',
}

export const LIST_UNIVERSITY = [
  { id: 'AMIENS', name: 'Amiens', value: 'AMIENS' },
  { id: 'ANGERS', name: 'Angers', value: 'ANGERS' },
  { id: 'BESANCON', name: 'Besançon', value: 'BESANCON' },
  { id: 'BORDEAUX', name: 'Bordeaux', value: 'BORDEAUX' },
  { id: 'CAEN', name: 'Caen', value: 'CAEN' },
  { id: 'CHATENAY_MALABRY', name: 'Châtenay-Malabry', value: 'CHATENAY_MALABRY' },
  { id: 'CLERMONT_FERRAND', name: 'Clermont-Ferrand', value: 'CLERMONT_FERRAND' },
  { id: 'DIJON', name: 'Dijon', value: 'DIJON' },
  { id: 'GRENOBLE', name: 'Grenoble', value: 'GRENOBLE' },
  { id: 'LILLE', name: 'Lille', value: 'LILLE' },
  { id: 'LIMOGES', name: 'Limoges', value: 'LIMOGES' },
  { id: 'LYON', name: 'Lyon', value: 'LYON' },
  { id: 'MARSEILLE', name: 'Marseille', value: 'MARSEILLE' },
  { id: 'MONTPELLIER', name: 'Montpellier', value: 'MONTPELLIER' },
  { id: 'NANCY', name: 'Nancy', value: 'NANCY' },
  { id: 'NANTES', name: 'Nantes', value: 'NANTES' },
  { id: 'PARIS_V', name: 'Paris V', value: 'PARIS_V' },
  { id: 'POITIERS', name: 'Poitiers', value: 'POITIERS' },
  { id: 'REIMS', name: 'Reims', value: 'REIMS' },
  { id: 'RENNES', name: 'Rennes', value: 'RENNES' },
  { id: 'ROUEN', name: 'Rouen', value: 'ROUEN' },
  { id: 'STRASBOURG', name: 'Strasbourg', value: 'STRASBOURG' },
  { id: 'TOULOUSE', name: 'Toulouse', value: 'TOULOUSE' },
  { id: 'TOURS', name: 'Tours', value: 'TOURS' },
]

export enum CountryEnum {
  FRANCE = 'FR',
  SPAIN = 'ES',
  BELGIUM = 'BE',
  LUXEMBOURG = 'LU',
  GERMANY = 'DE',
  ITALY = 'IT',
  SWITZERLAND = 'CH',
  UNITED_KINGDOM = 'GB',
}

export const COUNTRY_LIST = t => [
  {
    value: CountryEnum.FRANCE,
    name: t('common.country.france'),
    options: {
      administrativeRegion: [
        {
          value: 'ILE DE FRANCE',
          name: 'ILE DE FRANCE',
          zipCode: ['75', '77', '78', '91', '92', '93', '94', '95'],
        },
        {
          value: 'AUVERGNE - RHONE ALPES',
          name: 'AUVERGNE - RHONE ALPES',
          zipCode: ['01', '03', '07', '15', '26', '38', '42', '43', '63', '69', '73', '74'],
        },
        {
          value: "PROVENCE ALPES COTE D'AZUR",
          name: "PROVENCE ALPES COTE D'AZUR",
          zipCode: ['04', '05', '06', '13', '83', '84'],
        },
        {
          value: 'BOURGOGNE - FRANCHE COMTE',
          name: 'BOURGOGNE - FRANCHE COMTE',
          zipCode: ['21', '25', '39', '58', '70', '71', '89', '90'],
        },
        {
          value: 'OCCITANIE',
          name: 'OCCITANIE',
          zipCode: ['09', '11', '12', '30', '31', '32', '34', '46', '48', '65', '66', '81', '82'],
        },
        {
          value: 'BRETAGNE',
          name: 'BRETAGNE',
          zipCode: ['22', '29', '35', '56'],
        },
        {
          value: 'HAUTS DE FRANCE',
          name: 'HAUTS DE FRANCE',
          zipCode: ['02', '59', '60', '62', '80'],
        },
        {
          value: 'PAYS DE LA LOIRE',
          name: 'PAYS DE LA LOIRE',
          zipCode: ['44', '49', '53', '72', '85'],
        },
        {
          value: 'CENTRE VAL DE LOIRE',
          name: 'CENTRE VAL DE LOIRE',
          zipCode: ['18', '28', '36', '37', '41', '45'],
        },
        {
          value: 'GRAND-EST',
          name: 'GRAND-EST',
          zipCode: ['08', '10', '51', '52', '54', '55', '57', '67', '68', '88'],
        },
        {
          value: 'NOUVELLE AQUITAINE',
          name: 'NOUVELLE AQUITAINE',
          zipCode: ['16', '17', '19', '23', '24', '33', '40', '47', '64', '79', '86', '87'],
        },
        {
          value: 'CORSE',
          name: 'CORSE',
          zipCode: ['20'],
        },
        {
          value: 'NORMANDIE',
          name: 'NORMANDIE',
          zipCode: ['14', '27', '50', '61', '76'],
        },
        {
          value: 'DOM TOM',
          name: 'DOM TOM',
          // Polynésie, Wallis et Nouvelle-Calédonie : préfixe 98, comme Monaco.
          zipCode: ['97', '986', '987', '988'],
        },
        {
          value: 'MONACO',
          name: 'MONACO',
          zipCode: ['980'],
        },
      ],
      legalStatus: [
        { value: 'SELAS', name: 'Société d’exercice libéral par actions simplifiée' },
        { value: 'SAS', name: 'Société par Actions Simplifiée (SAS)' },
        { value: 'SARL', name: 'Société à Responsabilité Limitée (SARL)' },
        { value: 'SA', name: 'Société Anonyme (SA)' },
        { value: 'SNC', name: 'Société en Nom Collectif (SNC)' },
        {
          value: 'EURL',
          name: 'Entreprise Unipersonnelle à Responsabilité Limitée (EURL)',
        },
        {
          value: 'EIRL',
          name: 'Entreprise Individuelle à Responsabilité Limitée (EIRL)',
        },
        { value: 'SCA', name: 'Société en Commandite par Actions (SCA)' },
        { value: 'SCI', name: 'Société Civile Immobilière (SCI)' },
        { value: 'SASU', name: 'Société par Actions Simplifiée Unipersonnelle (SASU)' },
        { value: 'EI', name: 'Entreprise Individuelle (EI)' },
        { value: 'Micro-entreprise', name: 'Micro-entreprise' },
        { value: 'SDF', name: 'Société de fait' },
        { value: 'Nom propre', name: 'Nom propre' },
        {
          value: 'SELARL',
          name: "Société d'Exercice Libéral à Responsabilité Limitée(SELARL)",
        },
        {
          value: 'EARL',
          name: 'Exploitation Agricole à Responsabilité Limitée (EARL)',
        },
        {
          value: 'SELURL',
          name: 'Société d’exercice libéral à responsabilité limitée (SELURL)',
        },
        { value: LEGALSTATUS_OTHER, name: 'Autre' },
      ],
    },
  },
  {
    value: CountryEnum.ITALY,
    name: t('common.country.italy'),
    options: {
      administrativeRegion: [
        { value: 'ABRUZZE', name: 'ABRUZZO' },
        { value: 'BASILICATE', name: 'BASILICATA' },
        { value: 'CALABRIE', name: 'CALABRIA' },
        { value: 'CAMPANIE', name: 'CAMPANIA' },
        { value: 'EMILIE-ROMAGNE', name: 'EMILIA-ROMAGNA' },
        { value: 'FRIULI-VENEZIA GIULIA', name: 'FRIULI-VENEZIA GIULIA' },
        { value: 'LAZIO', name: 'LAZIO' },
        { value: 'LIGURIE', name: 'LIGURIA' },
        { value: 'LOMBARDIE', name: 'LOMBARDIA' },
        { value: 'MARCHE', name: 'MARCHE' },
        { value: 'MOLISE', name: 'MOLISE' },
        { value: 'OMBRIE', name: 'UMBRIA' },
        { value: 'PIÉMONT', name: 'PIEMONTE' },
        { value: 'POUILLES', name: 'PUGLIA' },
        { value: 'SARDINIE', name: 'SARDEGNA' },
        { value: 'SICILE', name: 'SICILIA' },
        { value: 'TOSCANE', name: 'TOSCANA' },
        { value: 'TRENTIN-HAUT ADIGE', name: 'TRENTINO-ALTO-ADIGE' },
        { value: "VAL D'AOSTE", name: "VALLE D'AOSTA" },
        { value: 'VÉNÉTIE', name: 'VENETO' },
      ],
      legalStatus: [
        { value: 'SRL', name: t('enum.legalStatus.italy.srl') },
        { value: 'SPA', name: t('enum.legalStatus.italy.spa') },
        { value: 'SAS', name: t('enum.legalStatus.italy.sas') },
        { value: 'SNC', name: t('enum.legalStatus.italy.snc') },
        { value: 'SD', name: t('enum.legalStatus.italy.sd') },
        {
          value: 'Srls',
          name: t('enum.legalStatus.italy.srls'),
        },
        { value: 'CEI', name: t('enum.legalStatus.italy.cei') },
        { value: LEGALSTATUS_OTHER, name: t('enum.legalStatus.other') },
      ],
    },
  },
  {
    value: CountryEnum.BELGIUM,
    name: t('common.country.belgium'),
    options: {
      administrativeRegion: [
        {
          value: 'BRUXELLES-CAPITALE',
          name: t('enum.administrativeRegion.belgium.bruxellesCapitale'),
        },
        { value: 'HAINAUT', name: t('enum.administrativeRegion.belgium.hainaut') },
        { value: 'NAMUR', name: t('enum.administrativeRegion.belgium.namur') },
        { value: 'LIEGE', name: t('enum.administrativeRegion.belgium.liege') },
        { value: 'LUXEMBOURG', name: t('enum.administrativeRegion.belgium.luxembourg') },
        { value: 'BRABANT-WALLON', name: t('enum.administrativeRegion.belgium.brabantWallon') },
        {
          value: 'FLANDRE-OCCIDENTALE',
          name: t('enum.administrativeRegion.belgium.flandreOccidentale'),
        },
        {
          value: 'FLANDRE-ORIENTALE',
          name: t('enum.administrativeRegion.belgium.flandreOrientale'),
        },
        { value: 'ANVERS', name: t('enum.administrativeRegion.belgium.anvers') },
        { value: 'BRABANT-FLAMAND', name: t('enum.administrativeRegion.belgium.brabantFlamand') },
        { value: 'LIMBOURG', name: t('enum.administrativeRegion.belgium.limbourg') },
      ],
      legalStatus: [
        { value: 'EI', name: t('enum.legalStatus.belgium.ei') },
        { value: 'SRL', name: t('enum.legalStatus.belgium.srl') },
        { value: 'SA', name: t('enum.legalStatus.belgium.sa') },
        { value: 'SNC', name: t('enum.legalStatus.belgium.snc') },
        { value: 'SC', name: t('enum.legalStatus.belgium.sc') },
        { value: 'Scomm', name: t('enum.legalStatus.belgium.scomm') },
        { value: LEGALSTATUS_OTHER, name: t('enum.legalStatus.other') },
      ],
    },
  },
  {
    value: CountryEnum.LUXEMBOURG,
    name: t('common.country.luxembourg'),
    options: {
      administrativeRegion: [
        { value: 'LUXEMBOURG', name: t('enum.administrativeRegion.luxembourg.luxembourg') },
        { value: 'DIEKIRCH', name: t('enum.administrativeRegion.luxembourg.diekirch') },
        { value: 'GREVENMACHER', name: t('enum.administrativeRegion.luxembourg.grevenmacher') },
      ],
      legalStatus: [
        { value: 'EI', name: t('enum.legalStatus.belgium.ei') },
        { value: 'SRL', name: t('enum.legalStatus.belgium.srl') },
        { value: 'SA', name: t('enum.legalStatus.belgium.sa') },
        { value: 'SNC', name: t('enum.legalStatus.belgium.snc') },
        { value: 'SC', name: t('enum.legalStatus.belgium.sc') },
        { value: 'SCOMM', name: t('enum.legalStatus.belgium.scomm') },
        { value: LEGALSTATUS_OTHER, name: t('enum.legalStatus.other') },
      ],
    },
  },
  {
    value: CountryEnum.SPAIN,
    name: t('common.country.spain'),
    options: {
      administrativeRegion: [
        { value: 'ANDALOUSIE', name: 'ANDALUCÍA' },
        { value: 'ARAGON', name: 'ARAGÓN' },
        { value: 'ASTURIAS', name: 'ASTURIAS' },
        { value: 'ÎLES BALEARES', name: 'BALEARES' },
        { value: 'CANARIES', name: 'CANARIAS' },
        { value: 'CASTILLE-LA MANCHA', name: 'CASTILLA-LA MANCHA' },
        { value: 'CASTILLE-ET-LEON', name: 'CASTILLA Y LEÓN' },
        { value: 'CATALONIE', name: 'CATALUÑA' },
        { value: 'COMMUNAUTÉ VALENCIENNE', name: 'COMUNIDAD VALENCIANA' },
        { value: 'EXTREMADURE', name: 'EXTREMADURA' },
        { value: 'GALICE', name: 'GALICIA' },
        { value: 'MADRID', name: 'MADRID' },
        { value: 'MURCIE', name: 'MURCIA' },
        { value: 'NAVARRE', name: 'NAVARRA' },
        { value: 'PAYS BASQUE', name: 'PAÍS VASCO' },
        { value: 'LA RIOJA', name: 'LA RIOJA' },
      ],
      legalStatus: [
        { value: 'SL', name: t('enum.legalStatus.spain.sl') },
        { value: 'SLA', name: t('enum.legalStatus.spain.sla') },
        { value: 'SA', name: t('enum.legalStatus.spain.sa') },
        { value: 'SCoop', name: t('enum.legalStatus.spain.scoop') },
        { value: 'SCS', name: t('enum.legalStatus.spain.scs') },
        { value: 'SC', name: t('enum.legalStatus.spain.sc') },
        { value: 'SLNE', name: t('enum.legalStatus.spain.slne') },
        { value: 'SAS', name: t('enum.legalStatus.spain.sas') },
        { value: LEGALSTATUS_OTHER, name: t('enum.legalStatus.other') },
      ],
    },
  },
  {
    value: CountryEnum.GERMANY,
    name: t('common.country.germany'),
    options: {
      administrativeRegion: [
        {
          value: 'BADEN-WÜRTTEMBERG',
          name: t('enum.administrativeRegion.germany.badenWurttemberg'),
        },
        { value: 'BAVIÈRE', name: t('enum.administrativeRegion.germany.bayern') },
        { value: 'BERLIN', name: t('enum.administrativeRegion.germany.berlin') },
        { value: 'BRANDENBOURG', name: t('enum.administrativeRegion.germany.brandenburg') },
        { value: 'BREMEN', name: t('enum.administrativeRegion.germany.bremen') },
        { value: 'HESSE', name: t('enum.administrativeRegion.germany.hessen') },
        { value: 'HOLSTEIN', name: t('enum.administrativeRegion.germany.schleswigHolstein') },
        {
          value: 'MECKLENBOURG-ANCIENNE-POMÉRANIE',
          name: t('enum.administrativeRegion.germany.mecklenburgVorpommern'),
        },
        { value: 'BASSE-SAXONNE', name: t('enum.administrativeRegion.germany.niedersachsen') },
        {
          value: 'RHIN-ALLEMAGNE',
          name: t('enum.administrativeRegion.germany.nordrheinWestfalen'),
        },
        { value: 'RHIN-SUPÉRIEUR', name: t('enum.administrativeRegion.germany.rheinlandPfalz') },
        { value: 'SAAR', name: t('enum.administrativeRegion.germany.saarland') },
        { value: 'SAXE', name: t('enum.administrativeRegion.germany.sachsen') },
        { value: 'SAXE-ANHALT', name: t('enum.administrativeRegion.germany.sachsenAnhalt') },
        { value: 'THURINGE', name: t('enum.administrativeRegion.germany.thuringen') },
      ],
      legalStatus: [
        { value: 'GmbH', name: t('enum.legalStatus.germany.gmbh') },
        { value: 'AG', name: t('enum.legalStatus.germany.ag') },
        { value: 'KG', name: t('enum.legalStatus.germany.kg') },
        { value: 'OHG', name: t('enum.legalStatus.germany.ohg') },
        { value: 'UG', name: t('enum.legalStatus.germany.ug') },
        { value: 'eK', name: t('enum.legalStatus.germany.ek') },
        { value: 'Freiberufler', name: t('enum.legalStatus.germany.freiberufler') },
        { value: LEGALSTATUS_OTHER, name: t('enum.legalStatus.other') },
      ],
    },
  },
  {
    value: CountryEnum.UNITED_KINGDOM,
    name: t('common.country.unitedKingdom'),
    options: {
      administrativeRegion: [
        { value: 'ANGLETERRE', name: t('enum.administrativeRegion.uk.england') },
        { value: 'ÉCOSSE', name: t('enum.administrativeRegion.uk.scotland') },
        { value: 'PAYS DE GALLES', name: t('enum.administrativeRegion.uk.wales') },
        { value: 'IRLANDE DU NORD', name: t('enum.administrativeRegion.uk.northernIreland') },
      ],
      legalStatus: [
        { value: 'LTD', name: t('enum.legalStatus.uk.ltd') },
        { value: 'PLC', name: t('enum.legalStatus.uk.plc') },
        { value: 'LLP', name: t('enum.legalStatus.uk.llp') },
        { value: 'Keb', name: t('enum.legalStatus.uk.keb') },
        { value: 'SoleTrader', name: t('enum.legalStatus.uk.soleTrader') },
        {
          value: 'CommunityInterestCompany',
          name: t('enum.legalStatus.uk.cic'),
        },
        { value: 'Charity', name: t('enum.legalStatus.uk.charity') },
        { value: LEGALSTATUS_OTHER, name: t('enum.legalStatus.other') },
      ],
    },
  },
  {
    value: CountryEnum.SWITZERLAND,
    name: t('common.country.switzerland'),
    options: {
      administrativeRegion: [
        { value: 'ARGOVIE', name: t('enum.administrativeRegion.switzerland.argovie') },
        { value: 'BASEL-CAMPAGNE', name: t('enum.administrativeRegion.switzerland.baselCampagne') },
        { value: 'BASEL-VILLE', name: t('enum.administrativeRegion.switzerland.baselVille') },
        { value: 'BERNE', name: t('enum.administrativeRegion.switzerland.berne') },
        { value: 'FRIBOURG', name: t('enum.administrativeRegion.switzerland.fribourg') },
        { value: 'GENÈVE', name: t('enum.administrativeRegion.switzerland.geneve') },
        { value: 'GLARIS', name: t('enum.administrativeRegion.switzerland.glaris') },
        { value: 'GRISONS', name: t('enum.administrativeRegion.switzerland.grisons') },
        { value: 'NEUCHÂTEL', name: t('enum.administrativeRegion.switzerland.neuchatel') },
        { value: 'NIDVALD', name: t('enum.administrativeRegion.switzerland.nidvald') },
        { value: 'OBWALD', name: t('enum.administrativeRegion.switzerland.obwald') },
        { value: 'SAINT-GALL', name: t('enum.administrativeRegion.switzerland.saintGall') },
        { value: 'SCHAFFHOUSE', name: t('enum.administrativeRegion.switzerland.schaffhouse') },
        { value: 'SOLOTHURN', name: t('enum.administrativeRegion.switzerland.solothurn') },
        { value: 'TESSIN', name: t('enum.administrativeRegion.switzerland.tessin') },
        { value: 'VAUD', name: t('enum.administrativeRegion.switzerland.vaud') },
        { value: 'VALAIS', name: t('enum.administrativeRegion.switzerland.valais') },
        { value: 'ZURICH', name: t('enum.administrativeRegion.switzerland.zurich') },
      ],
      legalStatus: [
        { value: 'AG', name: t('enum.legalStatus.switzerland.ag') },
        { value: 'GmbH', name: t('enum.legalStatus.switzerland.gmbh') },
        { value: 'Einzelfirma', name: t('enum.legalStatus.switzerland.einzelfirma') },
        {
          value: 'Kollektivgesellschaft',
          name: t('enum.legalStatus.switzerland.kollektivgesellschaft'),
        },
        { value: 'Genossenschaft', name: t('enum.legalStatus.switzerland.genossenschaft') },
        { value: 'Stiftung', name: t('enum.legalStatus.switzerland.stiftung') },
        { value: LEGALSTATUS_OTHER, name: t('enum.legalStatus.other') },
      ],
    },
  },
]
